import styled, { css } from 'styled-components';

export const Table = styled.table`
  display: table;
  width: 100%;
  box-shadow: ${({ theme }) => theme.boxShadow.md};
  border-radius: ${({ theme }) => theme.rounded.x5};
  background: ${({ theme }) => theme.palette.white};
  border-spacing: 0;
  overflow: auto;
  border-collapse: collapse;
`;
export const TableHead = styled.thead``;
export const TableHeadRow = styled.tr`
  display: table-row;
  height: ${({ theme }) => theme.spacing.x10};
  color: ${({ theme }) => theme.palette.white};
  font-size: ${({ theme }) => theme.fs.xxs};
  padding: 0 ${({ theme }) => theme.spacing.x3};
  overflow: hidden;
`;

export const TableHeadCell = styled.th<{ $dir }>`
  background: ${({ theme }) => theme.palette.primary};
  vertical-align: middle;
  ${({ theme }) =>
    theme.direction === 'ltr'
      ? css`
          &:first-child {
            border-top-left-radius: ${({ theme }) => theme.rounded.x4};
          }

          &:last-child {
            border-top-right-radius: ${({ theme }) => theme.rounded.x4};
          }
        `
      : css`
          &:first-child {
            border-top-right-radius: ${({ theme }) => theme.rounded.x4};
          }

          &:last-child {
            border-top-left-radius: ${({ theme }) => theme.rounded.x4};
          }
        `}
`;
export const TableBody = styled.tbody``;
export const TableRow = styled.tr<{ $expandable?; $expand? }>`
  font-size: ${({ theme }) => theme.fs.xs};
  padding: 0 ${({ theme }) => theme.spacing.x3};
  color: ${({ theme }) => theme.palette.primary};
  background: ${({ theme }) => theme.palette.gray40};

  &:nth-child(2n-1) {
    background: ${({ theme }) => theme.palette.lightestGray};
  }
  ${({ $expand }) =>
    $expand
      ? css`
          height: ${({ theme }) => theme.spacing.x9};
          max-height: ${({ theme }) => theme.spacing.x9};
          opacity: 1;
          visibility: visible;
          display: table-row;
        `
      : ''}

  ${({ $expandable }) =>
    $expandable
      ? css`
          height: 0px;
          max-height: 0;
          opacity: 0;
          visibility: hidden;
          transition: 0.2s;
          display: none;
        `
      : null}
`;

export const TableRowCell = styled.td`
  min-height: ${({ theme }) => theme.spacing.x10};
  text-align: center;
  padding: ${({ theme }) => ` ${theme.spacing.x4} ${theme.spacing.x8}`};
`;
export const Expandable = styled.div`
  height: 0px;
  max-height: 0;
  opacity: 0;
  visibility: hidden;
  transition: 0.2s;
  display: none;
  background: ${({ theme }) => theme.palette.gray40};

  &:nth-child(2n-1) {
    background: ${({ theme }) => theme.palette.gray40};
  }
`;
export const Expand = styled.div`
  height: ${({ theme }) => theme.spacing.x9};
  max-height: ${({ theme }) => theme.spacing.x9};
  opacity: 1;
  visibility: visible;
  display: table-row;
`;

export const TableCell = styled.td<{ $toghtder? }>`
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  padding: ${({ theme }) => ` ${theme.spacing.x2} ${theme.spacing.x4}`};
  @media (max-width: ${({ theme }) => theme.media.xs}) {
    padding: ${({ theme }) => ` ${theme.spacing.x2} ${theme.spacing.x2}`};
  }
  &:first-child {
    text-align: center;
  }
  ${({ $toghtder }) =>
    $toghtder
      ? css`
          background: ${({ theme }) => theme.palette.gray40};
          border-bottom: 1px solid #d8dfed;
        `
      : null}
`;

export const TitleExpand = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;

export const ExpandableRowSpan = styled.span`
  display: flex;
`;
export const ExpandableRowSvg = styled.svg<{ $active }>`
  ${({ $active }) =>
    $active
      ? css`
          transform: rotate(-180deg);
        `
      : css`
          transition: 0.2s;
        `}
`;
